// import { useEffect, useRef, useCallback, use } from 'react';
// import { useAppSelector, useAppDispatch } from './redux';
// import { addNotification } from '../store/slices/notificationsSlice';
// import { addMessage, updateMessageStatus } from '../store/slices/messagesSlice'; // Add this import
// import {Notification}  from '../types'

// interface WebSocketMessage {
//   type: string;
//   data: any;
//   user_id?: string;
//   timestamp: number;
// }

// const useWebSocket = () => {
//   const socketRef = useRef<WebSocket | null>(null);
//   const { user } = useAppSelector((state) => state.auth);
//   const dispatch = useAppDispatch();
//   const reconnectAttempts = useRef(0);
//   const maxReconnectAttempts = 5;

//   const connect = useCallback(() => {
//     if (!user?.id) return;

//     const WS_URL = `ws://localhost:3500/ws?user_id=${user.id}`;
    
//     try {
//       socketRef.current = new WebSocket(WS_URL);

//       socketRef.current.onopen = () => {
//         // console.log('✅ WebSocket connected');
//         reconnectAttempts.current = 0;
//       };

//       socketRef.current.onmessage = (event) => {
//         try {
//           const message: WebSocketMessage = JSON.parse(event.data);
//           // console.log('📨 WebSocket message received:', message);

//           switch (message.type) {
//             case 'new_message':
//                 // Handle new message - add to conversation messages
//                 // console.log('💬 New message:', message.data);
                
//                 // Add message to messages state for real-time updates
//                 if (message.data.message) {
//                   dispatch(addMessage(message.data.message));
//                 }
                
//                 // Also create a notification for the message
//                 const messageNotification: Notification = {
//                   id: `${message.data.message?.id}`,
//                   user_id: user.id,
//                   type: 'message',
//                   title: `New message from ${message.data.sender?.first_name} ${message.data.sender?.last_name}`,
//                   message: message.data.message?.content || 'New message received',
//                   action_type: 'open_chat',
//                   reference_id: message.data.conversation_id,
//                   reference_type: 'conversation',
//                   is_read: false,
//                   created_at: new Date().toISOString(),
//                   updated_at: new Date().toISOString(),
//                 };

//                 // const messNot = 
//                 //     type: 'message' | 'application' | 'booking' | 'general' | 'like' | 'comment' | 
//                 //           'collaboration_invite' | 'collaboration_accept' | 'collaboration_reject' | 'collaboration_update';
//                 //     requires_action?: boolean;
//                 //     expires_at?: string;
//                 //     responded_at?: string;
//                 //     created_at: string;
//                 //     updated_at: string;
//                 dispatch(addNotification(messageNotification));
//                 break;
                
//               case 'message_delivered':
//                 // Handle message delivery status
//                 // console.log('📬 Message delivered:', message.data);
//                 if (message.data.message_id) {
//                   dispatch(updateMessageStatus({
//                     messageId: message.data.message_id,
//                     status: { is_delivered: true }
//                   }));
//                 }
//                 break;
                
//               case 'message_read':
//                 // Handle message read status
//                 // console.log('👁️ Message read:', message.data);
//                 if (message.data.message_id) {
//                   dispatch(updateMessageStatus({
//                     messageId: message.data.message_id,
//                     status: { is_read: true }
//                   }));
//                 }
//                 break;
              
//             case 'notification':
//               // Handle new notification
//               // console.log('🔔 New notification:', message.data);
//               dispatch(addNotification(message.data));
//               break;
              
//             case 'collaboration_invite':
//               // Handle collaboration invite
//               // console.log('🤝 Collaboration invite:', message.data);
//               dispatch(addNotification(message.data));
//               break;
              
//             default:
//               // console.log('❓ Unknown message type:', message.type);
//           }
//         } catch (error) {
//           console.error('❌ Error parsing WebSocket message:', error);
//         }
//       };

//       socketRef.current.onclose = (event) => {
//         // console.log('🔌 WebSocket disconnected:', event.code, event.reason);
        
//         // Attempt to reconnect if not intentionally closed
//         if (event.code !== 1000 && reconnectAttempts.current < maxReconnectAttempts) {
//           reconnectAttempts.current++;
//           // console.log(`🔄 Reconnecting... Attempt ${reconnectAttempts.current}`);
//           setTimeout(connect, 2000 * reconnectAttempts.current);
//         }
//       };

//       socketRef.current.onerror = (error) => {
//         console.error('❌ WebSocket error:', error);
//       };

//     } catch (error) {
//       console.error('❌ WebSocket connection failed:', error);
//     }
//   }, [user?.id, dispatch]);

//   useEffect(() => {
//     // console.log("user?.id", user?.id)
//     if (user?.id) {
//       connect();
//     }

//     return () => {
//       if (socketRef.current) {
//         socketRef.current.close(1000, 'Component unmounted');
//         socketRef.current = null;
//       }
//     };
//   }, [connect]);

//   // Function to send messages through WebSocket
//   const sendMessage = useCallback((message: any) => {
//     if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
//       socketRef.current.send(JSON.stringify(message));
//     } else {
//       console.warn('⚠️ WebSocket not connected, cannot send message');
//     }
//   }, []);

//   return {
//     socket: socketRef.current,
//     sendMessage,
//     isConnected: socketRef.current?.readyState === WebSocket.OPEN
//   };
// };

// export default useWebSocket;


import { useWebSocketContext } from '../contexts/WebSocketContext';

export const useWebSocket = () => {
  const { socket, isConnected, sendMessage, connectionStatus, lastMessage } = useWebSocketContext();
  
  return {
    socket,
    isConnected,
    sendMessage,
    connectionStatus,
    lastMessage,
  };
};

export default useWebSocket;
